var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-max-3797388") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2-Experiment---Text-Use-this-model---Results-Copy-7",
    transform: "translate(-579.000000, -409.000000)",
    fill: "#A4A9C8",
    fillRule: "nonzero",
    stroke: "#A4A9C8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(103.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-max-3797388",
    transform: "translate(477.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9997604,0.499816795 L23.9997604,5.99967011 C23.9997604,6.27572992 23.7759296,6.4997269 23.4997015,6.4997269 C23.2236405,6.4997269 22.999814,6.27572992 22.999814,5.99967011 L22.999814,1.70495881 L18.3549402,6.35495557 C18.2610227,6.44954122 18.1331194,6.50277833 17.9998589,6.50277833 C17.8665984,6.50277833 17.7386951,6.44954122 17.6447776,6.35495557 C17.5501916,6.2610385 17.4969542,6.13313573 17.4969542,5.99987582 C17.4969542,5.86661591 17.5501916,5.73871315 17.6447776,5.64479607 L22.2947943,0.999942161 L18.0000646,0.999942161 C17.7240036,0.999942161 17.5000057,0.776112317 17.5000057,0.500056795 C17.5000057,0.223829844 17.7240036,0 18.0000646,0 L23.4999415,0 C23.5653974,0.000837042274 23.6298505,0.0143974185 23.6899536,0.0400109721 C23.8121655,0.0907366511 23.909263,0.187833726 23.9599889,0.31004507 C23.9856029,0.370143599 23.999163,0.434596412 24,0.500056366 L23.9997604,0.499816795 Z M6.35498281,17.6448049 C6.26106533,17.5502192 6.13316201,17.4969821 5.99990154,17.4969821 C5.86664106,17.4969821 5.73873774,17.5502192 5.64482026,17.6448049 L0.999946446,22.2948016 L0.999946446,18.0000903 C0.999946446,17.7240305 0.776115643,17.5000335 0.500058938,17.5000335 C0.223830803,17.5000335 0,17.7240305 0,18.0000903 L0,23.4999436 C0.000837045862,23.5653993 0.0143974802,23.6298521 0.0400111436,23.6899549 C0.09073704,23.8121663 0.187834531,23.9092633 0.310046399,23.959989 C0.370145186,23.985603 0.434598274,23.999163 0.500058509,24 L5.99993539,24 C6.27599638,24 6.5,23.7761702 6.5,23.4999432 C6.5,23.2238834 6.27599638,23.0000578 5.99993539,23.0000578 L1.70520569,23.0000578 L6.35522238,18.3552039 C6.44980844,18.2612869 6.50304577,18.1333841 6.50304577,18.0001242 C6.50304577,17.8668643 6.44980844,17.7389615 6.35522238,17.6450444 L6.35498281,17.6448049 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExpand);
export default __webpack_public_path__ + "static/media/ico-expand.3fa88662d7c54ffc9cea4f622607ff34.svg";
export { ForwardRef as ReactComponent };